/**
 * Created by admin on 2018/5/24.
 */
module.exports = {
    zh_en:{
        text:'中文/English'
    },
    logo:{
        src:'static/logo_en.png'
    },
    menu: {
        Sitemap: 'Sitemap',
        Home:'Home',
        Features:'Features',
        Products:'Products',
        FAQ:'FAQ',
        Blog:'Blog',
        Contact:'Contact Sales',
        About:'About'
    },
    contactInfo: {
        title: 'Contact information',
        email: 'Email: salesph@nelsoft.com.ph / sales@nelsoft.com.ph',
        cntel: 'Mobile: +63-917-8836968',
        entel: 'Web: www.lettuce.com.ph',
        contact:'Contact: LAW Roger',
        address: 'Address: 5th Floor #41 J. Mariano St., Corner EDSA Barangay 95, Caloocan City 1400',
        wechat: 'Wechat',
        wechatMsg: 'For Chinese Language Only',
    },
    header:{
        tit1:'Cashier POS',
        titSub1:{
            text1:'cashier',
            text2:'Ordering machine',
            text3:'Self-service machine',
            text4:'Printer',
        },
        tit2:'Backstage',
        titSub2:{
            text1:'Easy management of the table',
            text2:'Multiple devices ordering at the same time',
            text3:'Accelerate kitchen efficiency',
            text4:'Multiple payment methods',
        },
    },
    home: {
        moreBtn:'More',
        banner: {
            banner1: {
                bannerText: 'BIR ACCREDITED',
                bannerDetail: 'Philippine National Taxation Bureau BIR certification software, each cash register application for a formal cashier license.',
            },
            banner2: {
                bannerText: 'SHOPPING MALL COOPERATION',
                bannerDetail: 'LETTUCE POS has connected two major shopping malls business data API interface to make it easier for customers to enter the mall.',
            }
        },
        con1:{
            tit1:'Government certified',
            tit2:'Rich platforms',
            tit3:'Support multiple stores',
            tit4:'Remote management system',
            con1:'Philippines Govt Tax Department certifies  Lettuce to receive online payments.',
            con2:'Free configuration of multiple platforms to choose: Cashier Machine, ipad, Self-service Ordering Tablet',
            con3:'A single person can manage multiple stores operations at the same time. Making logistic and intuitive planning simple.',
            con4:'Remotely manage and synchronize data on table occupancy,menu,payment methods,cash register inputs, etc.',

        },
        con2: {
            title1: 'Cashier POS',
            title2: 'Backstage',
            table1:{
                title1: '01 Easy management of the table',
                titleSub1: 'The table arrangement is too busy to come?',
                con1: 'The lettuce has been designed differently for the different order status on the display of the table, and the in-store dining situation is clear at a glance.',
                title2: '02 Multiple devices ordering at the same time',
                titleSub2: 'The table arrangement is too busy to come?',
                con2: 'The lettuce has been designed differently for the different order status on the display of the table, and the in-store dining situation is clear at a glance.',
                title3: '03 Accelerate kitchen efficiency',
                titleSub3: 'The table arrangement is too busy to come?',
                con3: 'The lettuce has been designed differently for the different order status on the display of the table, and the in-store dining situation is clear at a glance.',
                title4: '04 Multiple payment methods',
                titleSub4: 'The table arrangement is too busy to come?',
                con4: 'The lettuce has been designed differently for the different order status on the display of the table, and the in-store dining situation is clear at a glance.',
                title5: '05 Taste, add as you like',
                titleSub5: 'Like the taste and addition of milk tea, ordering is very confusing?',
                con5: 'According to the characteristics of the product, the corresponding specifications, attributes, and materials can be selected, and the labels can be printed synchronously after the order is placed, and the order is simple and efficient.',
                title6: '06 Multiple promotions',
                titleSub6: "There are many holiday activities, and marketing can't keep up?",
                con6: 'A variety of promotional methods can be set in the background, and the specific time of the event can be selected. During the activity period, the cashier selects the activity, and the bill will automatically calculate the amount, which is reflected in the tax form and the backstage statistics.',
                title7: '07 Exchange class and cash management',
                titleSub7: 'Employees commuting to work, cash check difficulties?',
                con7: 'Submit cashiers and cash data to work every day, check again after the shift, the system will calculate the amount of receivables and the amount of error, management at a glance.',
                title8: '08 Support offline',
                titleSub8: 'The restaurant network environment is not good, what should I do if the signal is interrupted?',
                con8: 'The Lettuce cash register has large storage space, supports local data storage and offline operation, and is not afraid of network signal problems. When there is a network, synchronize the data to achieve cloud management.',
                title9: '09 Support Chinese and English',
                titleSub9: 'Special restaurants need Chinese and English?',
                con9: 'All devices and backgrounds support Chinese and English switching, easy to read and view; labels and documents can be printed in both English and Chinese, and the menu display is more intuitive.',
            },
            table2: {
                title1: '01 Store operation statistics',
                titleSub1: "Can't accurately analyze store revenue?",
                con1: 'The Lettuce back-end system has detailed records of various order details, data visualization charts, and revenue status at a glance.',
                title2: '02 Employee rights management',
                titleSub2: 'Does employee error affect store operations?',
                con2: 'The Lettuce back-end system can set detailed permission settings for employee accounts of different types of work, avoiding missteps and ensuring normal operation of the store.',
                title3: '03 Promotion management',
                titleSub3: 'Is the promotional cost unclear?',
                con3: 'The Lettuce backend system offers a high degree of customization. The front-end cashier combines the selected offers with the automatic conversion amount, and the promotion data can also be viewed in the background.',
                title4: '04 Multi-store management',
                titleSub4: 'Is it too troublesome to manage multiple stores?',
                con4: 'Lettuce back-end system can realize unified management of multiple stores, share preferential activities, product information, etc., eliminating the trouble of repeatedly entering information.',
                title5: '05 口味、加料随心选择',
                titleSub5: '奶茶口味、加料一样，点餐很混乱？',
                con5: '可以根据商品特征，选择相应的规格、属性、加料，下单后同步打印标签，出单简单又高效。',
                title6: '06 多种促销活动',
                titleSub6: '节假日活动多，营销跟不上？',
                con6: '后台可设置多种促销方式，并选择活动的具体时间。活动期间内收银员选择活动，账单便会自动计算金额，并体现在税单和后台的统计表中。',
                title7: '07 交换班和现金管理',
                titleSub7: '员工上下班，现金核对困难？',
                con7: '每天上班提交收银员和现金数据，交班后再次清点，系统会核算出应收金额和误差金额，管理一目了然。',
                title8: '08 支持离线',
                titleSub8: '餐厅网络环境不好，信号中断怎么办？',
                con8: 'Lettuce 收银机拥有超大存储空间，支持本地数据存储和离线操作，不惧网络信号问题。在有网络的时候 ，同步数据，即可实现云端管理。',
                title9: '09 支持中英文',
                titleSub9: '特殊餐厅需要中英文？',
                con9: '所有设备和后台都支持中英文切换，方便阅读和查看；标签和单据的打印也能同时中英文，菜单展示更直观。',
            }
        },
        con3: {
            // tit: 'Blog',
            // titSub: 'Lettuce system update introduction, customer case, activity',
            // detail:'See details'
            tit: 'Our Client',
            titSub: 'Shopping mall cooperation',
            detail: 'The following mall business data API interfaces have been connected(SM Mall, Ayala Malls)'
        },
        con4: {
            tit1: 'About Lettuce',
            tit2: 'Lettuce Limited is headquartered in Hong Kong, with R&D centers in Xiamen and Shenzhen, China; and branches in the Philippines and Malaysia.',
            titSub: 'Lettuce POS provides one-stop catering and localized POS catering system solutions for local catering companies of all sizes in Southeast Asia, enabling cloud management and powerful operational data analysis capabilities to help…'
        }
    },
    blog:{
        bannerText:'BLOG',
        bannerDetail:'Lettuce system update introduction, customer case, activity',
    },
    about: {
        bannerText: 'ABOUT US',
        bannerDetail: 'Professional smart food system manufacturer in Southeast Asia',
        tit:'About Lettuce',
        detail1:'Lettuce Limited established in 2018, is headquartered in Hong Kong, with branches and operation centers in Xiamen, Shenzhen, the Philippines, Malaysia, and Thailand.',
        detail2:'Lettuce is one of the most used catering systems in Southeast Asian countries. It provides one-stop solutions for catering companies, shopping malls, supermarkets, etc. of various sizes in Southeast Asian countries that comply with local laws, taxation, and localized POS systems to achieve cloud management and powerful  Its operational data analysis capabilities have helped the rapid development of catering companies, shopping malls and supermarket companies.',
        detail3:'Entered the Philippine market in 2018. In just three years, it has served more than 10,000 physical merchants and has a high degree of influence in the Philippine market; entered the Malaysian market in 2019 and was recognized by customers; entered the Thai and Hong Kong markets at the same time in 2020; It is expected to enter the Indonesian and Myanmar markets in 2021; Lettuce has served more than 12,000 physical merchants in Southeast Asian countries.',
        detail4:'We have reached strategic partnerships with VISA, MasterCard, UnionPay, WechatPay, Wechat, Alipay, BDO UNIBANK, Paymaya, GCash, Yedpay, QFPAY, FUCENT GATEWAY Fuxin, SM SUPERMALLS, Ayala Malls, Lazada, Shopee, etc. in Southeast Asian countries relationship.'
    },
    contact: {
        bannerText: 'CONTACT US',
        bannerDetail: 'Please contact the sales staff or leave us a message if you need it.',
        contactNumber:{
            tit:'Contact information',
            cnTel:'Mobile: +63-917-8836968',
            EnTel:'Email: salesph@nelsoft.com.ph / sales@nelsoft.com.ph',
            time:'Contact: LAW Roger',
        },
        contactAddress:{
            tit:'Contact address',
            address1:'Address:5th Floor #41 J. Mariano St., Corner EDSA Barangay 95, Caloocan City 1400',
            address2:'Web: www.lettuce.com.ph',
        },
        contactWechat:'WeChat',
        contactUs:{
            tit:'Contact us',
            tips:'We are happy to help you quickly install lettuce to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.',
            submitBtn:'Submit'
        }
    },
    faq: {
        bannerText: 'FAQ',
        bannerDetail: 'If there are other questions? Please contact staff 4008-88-99, welcome your inquiry',
        listName1: 'Products and features',
        listName2: 'Hardware and network',
        listName3: 'Customer Support',
        queList1:{
            title1:'What is Lettuce?',
            title2:'What is the Lettuce backstage?',
            detail1:'Lettuce is a catering management software based on the actual situation of the Philippines (Southeast Asian countries?), providing one-stop compliance with local legal taxation, localized catering solutions, cloud management, and powerful operational data analysis capabilities to assist catering companies. rapid development',
            detail2:'Lettuce backstage is a platform for catering business managers to manage all stores and operations. Managers can flexibly configure tables, dishes, special offers, personnel management, etc. in the background; store data, various reports, personnel Check the handover situation.',
            title3:'What is Lettuce?',
            title4:'What is the Lettuce backstage?',
            detail3:'Lettuce is a catering management software based on the actual situation of the Philippines (Southeast Asian countries?), providing one-stop compliance with local legal taxation, localized catering solutions, cloud management, and powerful operational data analysis capabilities to assist catering companies. rapid development',
            detail4:'Lettuce backstage is a platform for catering business managers to manage all stores and operations. Managers can flexibly configure tables, dishes, special offers, personnel management, etc. in the background; store data, various reports, personnel Check the handover situation.',
            title5: 'Equipment that supports the lettuce system?',
            title6: 'I have a number of stores, can I manage them in a unified way?',
            title7: 'Is the new store setting complicated? If there are multiple stores, do you want to repeat the settings?',
            title8: 'How do I update the settings of the Lettuce Cash Register?',
            title9: 'What payment methods does Lettuce POS support?',
            title10: 'How will different administrators assign usage features?',
            detail5: 'Lettuce will be available on Lettuce matching cash registers, ordering machines.',
            detail6: 'Yes, the administrator can log in to the Lettuce management back office and will be able to manage all stores in a unified manner.',
            detail7: 'Quite simply, the staff of Lettuce will assist with the first store setup. If the settings of other stores are similar to those of the first store, you can use the one-click copy function to copy the settings to other stores, and also make flexible modifications.',
            detail8: 'Click the Data Sync button (fill in the steps) to update the settings in the background to the cash register.',
            detail9: 'General: Support cash, Visa, MasterCard, AMEX, UnionPay, BDO, PayMaya, WeChat Pay, Alipay and other payment methods;\nCustomized payment: A unique payment method that supports access to special merchants.',
            detail10: 'Lettuce backends, can set permissions roles (for example: cashiers, managers, etc.) and assign them different functions, the user has no permission to use the features that are not assigned to him.',
        },
        queList2: {
            title1: 'What are the basic conditions for installing hardware?',
            title2: 'How to operate the system if there is no network?',
            title3: 'How to set up the printer?',
            title4: 'How to solve common printer problems?',
            detail1: 'The installer will come to the door to install the router and network cable, and connect to the cash register to use.',
            detail2: 'Cash registers and ordering machines can be used without a network (routers and network cables need to be in a normal state); self-service machines need to be used in the presence of a network.',
            detail3: '1、the first installer will set the printer IP\n2、In the Lettuce Management Background - Print Settings - Add Printer (Enter IP and other information as prompted)\n3、Cash register, ordering machine, self-service machine click data update, and check printer management - display the printer is connected.',
            detail4: '1 、Check if there is no paper, and if the paper is reversed;\n 2、Check whether the router is enabled, the network cable is normal, and the printer needs a network cable to connect to the router.\n3、Restart the printer;\n4、If the hardware is damaged, please contact the installer.',
        },
        queList3: {
            title1: 'How to get installation instructions and training?',
            title2: 'What is included in the after-sales service?',
            title3: 'After sales contact?',
            title4: 'Is the tax number application and tax return service?',
            detail1: 'On-site installation, training, technical guidance for the opening of the site, a total of 3 days free.',
            detail2: '1、Customer service phone and remote connection service: Monday to Friday (9:00-18:00) does not include holidays.\n2、On-site technical guidance: 1000 Philippine dollars per day in the province of Manila, 2000 Philippine dollars per day, reimbursement of tolls and accommodation.\n3、The hardware warranty period is 1 year.',
            detail3: {},
            detail4: 'Including the application for a cash register tax permit, does not include tax payment for customers.',
        }
    }
};



// WEBPACK FOOTER //
// ./src/langs/en.js